'use client';

import get from 'lodash/get';
import React from 'react';
import LinkDropdown from './LinkDropdown';

const LinkPage = ({ linkPages }) => {
  return <LinkDropdown links={get(linkPages, 'results', [])} />;
};

export default LinkPage;
